const pagination = require('./pagination');

function mapInit() {
    var map = new AMap.Map('mapContainer', {
        resizeEnable: true,
        zoom: 16,//级别
        center: [116.397428, 39.90923],
        viewMode: '3D'//使用3D视图
    });

    var lnglats = [
        [116.368904, 39.923423],
        [116.382122, 39.921176],
        [116.387271, 39.922501],
        [116.398258, 39.914600]
    ];
    var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
    for (var i = 0, marker; i < lnglats.length; i++) {
        var marker = new AMap.Marker({
            position: lnglats[i],
            map: map
        });
        marker.content =("<div>我是第"+ (i + 1) +"个Marker</div><div>电话：010-64733333</div>")
        marker.on('click', markerClick);
        // marker.emit('click', { target: marker });
    }

    function markerClick(e) {
        infoWindow.setContent(e.target.content);
        infoWindow.open(map, e.target.getPosition());
    }
    map.setFitView();
    
}
/**
 * 动态向产地列表内容区添加产地信息
 * @param
 *      products: [ProductionPlaceEntity]
 */
function appendProductionPlacesToDOM(products) {
  const divProductContent = $('.area-content-warpper .production-place-list');
  divProductContent.html('');
  const productionPlace = require('./productionPlace');
  const htmlText = productionPlace.productionPlaceDatas2List(products);
  divProductContent.append(htmlText);
  divProductContent.append('<div class="pagination"></div>');

  const bannerAPI = require("./index.js");
  bannerAPI.areaCarouselInit();
}
/**
 * 加载产地列表数据
 * @param {产地列表分页当前索引} nIndex
 * @param {数据加载完成回调} fn
 */
function loadPageData(nIndex, fn) {
  $.ajax({
    type: 'GET',
    url: '/area/list',
    data: {
      'pageIndex': nIndex
    },
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        appendProductionPlacesToDOM(response.data.datas);
        fn && fn(response.data);
      } else {
      }
    }
  });
}

function appendProductsToDOM(products) {
  const divProductContent = $('.area-detail-content div .product-warpper .product-content');
  divProductContent.html('');
  products.forEach(product => {
    let htmlText = '<div class="product">';
    htmlText += ('<a href="/product/detail/' + product.id + '">');
    htmlText += ('<img src="' + (product.picUrl && (typeof (product.picUrl) === 'string' ? product.picUrl : product.picUrl[0])) + '" />');
    htmlText += ('</a>');
    htmlText += ('<div class="product-name">' + product.name + '</div>');
    if (product.price) {
      htmlText += ('<div class="price">价格：');
      htmlText += ('<span class="price-icon">￥</span>');
      htmlText += ('<span>' + product.price + '</span>');
      htmlText += ('</div>');
    }
    if (product.supplierName) {
      htmlText += ('<div class="supplier">供应商：' + product.supplierName + '</div>');
    }
    htmlText += ('<div class="product-label">');
    if (product && product.labels) {
        product.labels.forEach(element => {
            var tmpSrc = ('<img style="width:auto;height: auto" src="/static/image/productDetail/');
            if (element == 9){
                tmpSrc += ('lvse.png" />');
            }
            else if (element == 4) {
                tmpSrc += ('baoxian.png" />');
            }
            else if (element == 1) {
                tmpSrc += ('chandi.png" />');
            }
            else if (element == 2) { 
                tmpSrc += ('hexinchandi.png" />');
            }
            else if (element == 3) {
                tmpSrc += ('jiance.png" />');
            }
            else if (element == 5) {
                tmpSrc += ('suyuan.png" />');
            }
            else if (element == 6) {
                tmpSrc += ('renzheng.png" />');
            }
            else if (element == 7) {
                tmpSrc += ('wugonghai.png" />');
            }
            else if (element == 8) {
                tmpSrc += ('youji.png" />');
            }
            else if (element == 'A' || element == 'a' || element == 10) {
                tmpSrc += ('dibiao.png" />');
            }
            else if (element == 'B' || element == 'b' || element == 11) {
                tmpSrc += ('fupen.png" />');
            }
            else {
                tmpSrc = null;
            }

            if (tmpSrc && tmpSrc.length > 0) {
                htmlText += tmpSrc;
            }
        });
    }
    htmlText += ('</div>');
    htmlText += ('</div>');
    divProductContent.append(htmlText);
  });
}

function loadProductionPlaceProducts(nIndex, fn) {
  const strProductionPlaceID = $('.content .area-detail-title .area-detail').attr('data');
  $.ajax({
    type: 'GET',
    url: '/area/products',
    data: {
      'pageIndex': nIndex,
      'id': strProductionPlaceID
    },
    success: function(response) {
      if (response && (response.errno == 0) && response.data && response.data.datas) {
        appendProductsToDOM(response.data.datas);
        fn && fn(response.data);
      } else {
      }
    }
  });
}

const init = () => {
  // mapInit();
  // PC端 产地列表分页点击
  let paginationPath = '.area-content-warpper div.pagination';
  pagination.bindItemClickEvent(paginationPath, null, loadPageData);
  // PC端 产地详情页中产品列表分页点击
  paginationPath = '.area-detail-content div div.pagination';
  pagination.bindItemClickEvent(paginationPath, null, loadProductionPlaceProducts);
};
module.exports = { init };
